import { action } from "@ember/object"
import { inject } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type {
  RotationCalendar,
  RotationCalendarDateAnnotation,
} from "@shared/models/rotation-calendar"
import type RotationEditor from "cc-frontend/services/rotation-editor"

export interface Sig {
  Args: {
    dateString: string
    isDelete: boolean
    additionType: "RESET" | "SKIP"
    rotationCalendar: RotationCalendar
    courses: Array<Course>
    planbook: Planbook
    exception?: RotationCalendarDateAnnotation
    closeMenu: Function
    goBack: Function
  }
}

export default class ConfirmRotationResetBodyComponent extends Component<Sig> {
  @inject rotationEditor!: RotationEditor
  @inject notifier

  @action addReset() {
    this.rotationEditor.resetRotation({
      dateString: this.args.dateString,
      rotationCalendar: this.args.rotationCalendar,
      courses: this.args.courses,
      planbook: this.args.planbook,
    })
    this.args.closeMenu()
    let formattedDate = dateFns.format(dateFns.parse(this.args.dateString), "MMM Do, YYYY")
    this.notifier.success("", {
      title: `The rotation cycle now restarts on ${formattedDate}`,
      message: "Click the Undo Button to undo this.",
      duration: 5000,
    })
  }

  @action addSkip() {
    this.rotationEditor.skipRotation({
      dateString: this.args.dateString,
      rotationCalendar: this.args.rotationCalendar,
      planbook: this.args.planbook,
      courses: this.args.courses,
    })
    this.args.closeMenu()
    let formattedDate = dateFns.format(dateFns.parse(this.args.dateString), "MMM Do, YYYY")
    this.notifier.success("", {
      title: `The rotation cycle now skips ${formattedDate}`,
      message: "Click the Undo Button to undo this.",
      duration: 5000,
    })
  }

  @action removeReset() {
    if (this.args.exception) {
      this.rotationEditor.removeDateAnnotation({
        rotationCalendar: this.args.rotationCalendar,
        dateAnnotation: this.args.exception,
        planbook: this.args.planbook,
        courses: this.args.courses,
      })
      this.args.closeMenu()
      let formattedDate = dateFns.format(dateFns.parse(this.args.dateString), "MMM Do, YYYY")
      this.notifier.success("", {
        title: `The restart on ${formattedDate} has been removed`,
        message: "Click the Undo Button to undo this.",
        duration: 5000,
      })
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::DayMenu::ConfirmRotationReset::Body": typeof ConfirmRotationResetBodyComponent
    "planner/menus/day-menu/confirm-rotation-reset/body": typeof ConfirmRotationResetBodyComponent
  }
}
